import { render, staticRenderFns } from "./GatButtonGroup.vue?vue&type=template&id=0ec32684&scoped=true&"
import script from "./GatButtonGroup.vue?vue&type=script&lang=js&"
export * from "./GatButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec32684",
  null
  
)

export default component.exports